import type { PropsPromo } from "@/lib/odds-screen/live/types";

type PromoTerms = { readonly cap: number; readonly maxPerLineup: number };

const TERMS_BY_BOOK: Readonly<Record<string, PromoTerms>> = {
  prizepicks: { cap: 25, maxPerLineup: 1 },
};

export function promoWithBookTerms(book: string, promo: PropsPromo | null): PropsPromo | null {
  const terms = TERMS_BY_BOOK[book];
  return promo === null || terms === undefined ? promo : { ...promo, cap: terms.cap, maxPerLineup: terms.maxPerLineup };
}
